import { Core } from './core/core';
export * from './decorators';
export var Validator;
(function (Validator) {
    function validate(object) {
        return Core.validate(object);
    }
    Validator.validate = validate;
})(Validator || (Validator = {}));
